import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NbGlobalPosition, NbToastrService  } from '@nebular/theme';
import { NbDialogRef } from '@nebular/theme';
import {StreamsService} from '../../../../services/streams.service';

@Component({
  selector: 'app-chat-blacklist-modal',
  templateUrl: './chat-blacklist-modal.component.html',
  styleUrls: ['./chat-blacklist-modal.component.scss']
})
export class ChatBlacklistModalComponent implements OnInit, OnDestroy{

	

	banList:any;
	loading:boolean = false;
	chat$:any= null;
	 rm$:any= null;
	@Input() chat_id;
	@Input() socket;
         

	constructor(     private streamsService : StreamsService, protected ref: NbDialogRef<ChatBlacklistModalComponent>){}
    
	 ngOnInit() {
	this.loading = true
	 this.chat$ = this.streamsService.getOwnChatBanlist(this.chat_id)
	      .subscribe((chat: any)=>{ this.banList = chat.blackList; this.loading = false},()=>{this.loading = false})

		
	 }


	removeFromList(id,socId){
		if( this.rm$) this.rm$.unsubscribe
	   	
		 

		// this.banList = this.banList.filter(i=>i._id!==id)

		this.rm$ = this.streamsService.delOwnChatBanlistItem(this.chat_id, id).subscribe((resp:any)=>{
			this.banList = this.banList.filter(i=>i._id!==id);
			this.socket.emit('clearBan', socId)

		}) /**/

	}


	 closeModal() {
	    this.ref.close();
	  }


  	ngOnDestroy(){

		if( this.chat$) this.chat$.unsubscribe
			if( this.rm$) this.rm$.unsubscribe
	}

}
